export default defineNuxtPlugin((nuxtApp) => {
    // if (!process.client || process.dev) return; // ❌ stop en SSR ou dev
/*
    const GA_ID = useRuntimeConfig().public.googleAnalyticsID;
    if (!GA_ID) {
        console.warn('GA ID missing');
        return;
    }

    // ⚡ Inject gtag.js script
    if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GA_ID}"]`)) {
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
        script.async = true;
        document.head.appendChild(script);
    }

    // ⚡ Inject gtag config safely (CSP friendly)
    window.dataLayer = window.dataLayer || [];
    const gtag = (...args) => window.dataLayer.push(args);
    window.gtag = window.gtag || gtag;

    window.gtag('js', new Date());
    window.gtag('config', GA_ID, { send_page_view: false });

    // ⚡ SPA page tracking
    nuxtApp.hook('page:finish', () => {
        window.gtag('event', 'page_view', {
            page_path: window.location.pathname
        });
    });
 */
});
